import NavrhAktuEuList from './NavrhAktuEuList';

export default NavrhAktuEuList;
